export default "__VITE_ASSET__XV2vshiw__"